import ApiCall from "../../../utils/apiCall";

export function getSetupIntent() {
  return function() {
    return ApiCall.get("/stripe_integrations/intent");
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/stripeIntegration/setupIntent.js